import { render, staticRenderFns } from "./ktv.vue?vue&type=template&id=c9f63488&scoped=true&"
import script from "./ktv.vue?vue&type=script&lang=js&"
export * from "./ktv.vue?vue&type=script&lang=js&"
import style0 from "./ktv.vue?vue&type=style&index=0&id=c9f63488&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f63488",
  null
  
)

export default component.exports